<template>
    <div id="bene-bank-transfer-bank-name-container">
        <f7-list form class="form-group" v-if="showFormSet.bankTransfer">
            <f7-list-input
                input-id     ="bankName"
                id           ="bankNameInput"
                name         ="bankName"
                class        ="clickable-row use-chevron"

                v-if         ="showFormInput.bankTransfer.bankName && !isAutocomplete"
                :label       ="bankNameLabel"
                :placeholder ="bankNamePlaceholder"
                :value       ="bankName"
                @change      ="changeBank($event.target.value);"
                v-show       = "!isAutocomplete"
                autocomplete ="off"
                :disabled    ="isBankNameDisabled"
                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-bank" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover v-if="!isAutocomplete" id="dropdownBankName" class="popover-dropdown-bank dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="(bl, key) in bankList"
                    :key="key"
                    selected=""
                    @click="changeBank(key); setInput('bankName');">
                        {{bl}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <f7-list-input v-if="isAutocomplete"
                input-id     ="bankNameAutocomplete"
                name         ="bankName"
                type         ="text"

                :label       ="bankNameLabel"
                :placeholder ="bankNamePlaceholder"
                :value       ="bankName"
                v-show       ="isAutocomplete"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            // console.log("isbKashTx: "+ this.isbKashTx);
            this.isBankNameDisabled = this.isbKashTx ? true : false;
            // console.log("isBankNameDisabled: "+ this.isBankNameDisabled);
            this.init();
        },
        data: function() {
            return {
                isBankNameDisabled: false,
            }
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'bankName',
                'bankId',
                'bankNameLabel',
                'bankNamePlaceholder',
                'isbKashTx',
                'bankList',
                'showPreloaderState',
                'validateInputState',
                'isCreateBeneficiary',
                'isAutocomplete'
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setBank',
                'setShowPreloaderState'
            ]),

            async init() {
                const self    = this;
                const popover = ".beneficiary.popover-dropdown-bank";
                const popoverInner = ".beneficiary.popover-dropdown-bank .popover-inner";
                const popoverId = "dropdownBankName";
                const inputId = "bankName";
                const inputListId = "#bankNameInput";
                await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)

                //console.log("BANK LIST LENGTH : "+ Object.keys(self.bankList).length)
                //console.log("BANK LIST : ", self.bankList)

                const app          = self.$f7;
                self.autocompleteBankName = app.autocomplete.create({
                    inputEl: '#bankNameAutocomplete',
                    openIn : 'dropdown',
                    class  : '',
                    closeOnSelect: true,
                    source : function(query, render) {
                        let results = [];
                        if(query.length === 0) {
                            //render(results);
                            self.autocompleteBankName.close();
                            return;
                        }else{
                            self.autocompleteBankName.open();
                        }

                        // Find Matched Items
                        Object.keys(self.bankList).forEach(key => {
                            if(self.bankList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                                results.push(self.bankList[key]);
                            }
                        })

                        // Render Items By Passing Array With Result Items
                        render(results.sort());
                    },
                    on     : {
                        change : function(val){
                            //console.log("SELECTED : "+val)

                            let selectedBankId = 0;
                            let entries = Object.entries(self.bankList)
                            entries.map( ([bankId, bankName]) => {
                                if(bankName.toString().toLowerCase() == val.toString().toLowerCase()){
                                    selectedBankId = bankId;
                                }
                            });

                            self.changeBank(selectedBankId)
                            self.validateInput(document.getElementById("bankNameAutocomplete"))
                        }
                    }
                })
            },

            changeBank(id) {
                this.setShowPreloaderState({name: "bankName", value: true});
                this.showPreloader();
                this.$emit("changeBank", id);
                if(this.showPreloaderState.name == "bankName" && this.showPreloaderState.value) {
                    this.hidePreloader();
                }
            },

            validateInput(inputEl) {
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl) {
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>